export const profilePopoverTheme = {
  activeLanguageBg: 'palette.surface.4',
  email: 'palette.neutral.60',
  error: 'palette.error.60',
  item: {
    base: 'palette.tertiary.70',
    hover: 'palette.tertiary.95',
    pressed: 'palette.tertiary.90',
  },
  logout: {
    base: 'palette.tertiary.70',
    hover: 'palette.tertiary.95',
    pressed: 'palette.tertiary.90',
  },
  name: 'palette.tertiary.95',
  periodEditor: {
    cancelButton: 'palette.error.70',
    saveButton: 'palette.success.70',
  },
  photo: {
    bg: 'palette.primary.20',
    borderRadius: '35px',
    icon: 'palette.primary.95',
  },
  row: {
    borderColor: 'palette.neutral.20',
    borderWidth: '1px',
  },
  switcher: {
    bg: 'palette.neutral.20',
    borderRadius: '20px',
  },
};
